import { render, staticRenderFns } from "./appCenter.vue?vue&type=template&id=07584766&"
import script from "./appCenter.vue?vue&type=script&lang=js&"
export * from "./appCenter.vue?vue&type=script&lang=js&"
import style0 from "./appCenter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports